// extracted by mini-css-extract-plugin
export default {"container":"styles_container__SjecV","text_center":"styles_text_center__EsByX","phone":"styles_phone__dGatG"};